import React from 'react'
import { useSelector } from 'react-redux'
import RefreshIcon from 'transfix-icons/build/RefreshIcon'
import { Button } from 'transfix-ui/components/Button'
import { ICarrierState } from 'types/carrier'
import { useModalState } from 'utils/hooks/useModalState'
import { IStore } from 'apps/carrier/utils/reducers'
import { UpdateMarketplaceDataModal } from './UpdateMarketplaceDataModal'

const UpdateMarketplaceDataButton = () => {
  const { carrierDetails } = useSelector<IStore, ICarrierState>(({ carrier }) => carrier)
  const { id: carrierApplicationId = '' } = carrierDetails || {}

  const {
    createToggleHandler,
    modalState: { updateMarketplaceDataModal: isUpdateMarketplaceDataModalOpen },
  } = useModalState({ updateMarketplaceDataModal: false })
  const openUpdateMarketplaceDataModal = createToggleHandler('updateMarketplaceDataModal', true)
  const closeUpdateMarketplaceDataModal = createToggleHandler('updateMarketplaceDataModal', false)

  return (
    <>
      <Button
        size='small'
        color='primary'
        startIcon={<RefreshIcon />}
        data-test='update-mp-data-button'
        onClick={openUpdateMarketplaceDataModal}>
        Update Marketplace Data
      </Button>
      {isUpdateMarketplaceDataModalOpen && (
        <UpdateMarketplaceDataModal
          onClose={closeUpdateMarketplaceDataModal}
          carrierApplicationId={carrierApplicationId}
        />
      )}
    </>
  )
}

export default UpdateMarketplaceDataButton
